export function init() {
    const $blogPost = $('.main__body--article');

    if ($blogPost.length) {

        if ($('h2').length) {
            setTimeout(() => {
                buildToc();
            });

            toggleArticleToc();
        } else {
            $('.menu--toc').hide();
        }

    }
}

function createAnchorLinks(list) {
    // Take all H2 tags and add to ToC list
    $("h2").each(function (index, value) {

        // Make sure H2 tag is located within the main body of article
        if (!$(this).hasClass("modal__title")) {
            $(this).attr('id', "section-" + (index + 1));
            $(this).attr('class', 'h6 anchor');

            let tocListItem = document.createElement("li");
            tocListItem.classList.add("menu__list--item");

            let tocEntry = document.createElement("a");
            tocEntry.setAttribute("href", "#" + $(this).attr("id"));
            tocEntry.innerText = $(this).text();

            tocListItem.appendChild(tocEntry);
            list.appendChild(tocListItem);
        }

    });
}

function toggleArticleToc() {
    $("#menu__list__title").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#menu__list__toc").slideToggle();
        updateCaret();
    });
}

function updateCaret() {
    $("#menu__list__caret").text(($("#menu__list__caret").text() == '-') ? '+' : '-');
}

function buildToc() {
    let toc = document.getElementById("menu__list__toc");

    // Create a list for the ToC entries
    let tocList = document.createElement("ul");
    tocList.classList.add("menu__list");

    createAnchorLinks(tocList);
    toc.appendChild(tocList);
    formatSmScreenToc();
}

function formatSmScreenToc() {
    // Collapse TOC if loaded media screen is smaller than 640px
    const mediaQuery = window.matchMedia('(max-width: 640px)');
    if (mediaQuery.matches) {
        $("#menu__list__toc").hide();
        updateCaret();
    }
}